import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from "@app/interfaces";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DefectsService = /** @class */ (function (_super) {
    tslib_1.__extends(DefectsService, _super);
    function DefectsService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    DefectsService.prototype.addEditDefects = function (data) {
        return this.http.post(this.getApiUrl("addEditDefect"), data);
    };
    DefectsService.prototype.getDefectsPipelineStages = function (pipelineId, payload) {
        return this.http.post(this.getApiUrl("sales/getDefectsPipelineStages/" + pipelineId), payload);
    };
    DefectsService.prototype.getDefectsByCustomer = function (customerId, params) {
        if (customerId === void 0) { customerId = 0; }
        if (params === void 0) { params = {}; }
        return this.http.post(this.getApiUrl("sales/getDefectByCustomer/" + customerId), params);
    };
    DefectsService.prototype.getDefectsByStages = function (pipelineId, params) {
        return this.http.post(this.getApiUrl("sales/getDefectsByStages/" + pipelineId), params);
    };
    DefectsService.prototype.getDefectsPipelines = function (params) {
        return this.http.get(this.getApiUrl("getDefectsRecommendPipelines", params));
    };
    DefectsService.prototype.addProposal = function (customerId, data) {
        return this.http.post(this.getApiUrl("sales/addDefectsProposal/" + customerId), data);
    };
    DefectsService.prototype.getDefectsRecommendationFilterFields = function (screenType) {
        return this.http.get(this.getApiUrl("sales/getDefectRecommendationFilter/" + screenType));
    };
    DefectsService.prototype.updateDefectsStage = function (payload) {
        return this.http.post(this.getApiUrl("sales/updateDefectsStage"), payload);
    };
    DefectsService.prototype.updateDefectsStatus = function (status, defectIds) {
        return this.http.post(this.getApiUrl("sales/updateDefectsStatus"), { status: status, defectIds: defectIds });
    };
    DefectsService.prototype.deleteDefect = function (id, pipelineId) {
        return this.http.delete(this.getApiUrl("sales/deleteDefect/" + id + "?pipelineId=" + pipelineId));
    };
    DefectsService.prototype.getDefectsPipelineAndStages = function (params) {
        return this.http.post(this.getApiUrl("sales/getDefectsPipelineAndStages"), params);
    };
    DefectsService.prototype.saveSelectedView = function (data) {
        var url = this.getApiUrl("userColumnOrder");
        return this.http.post(url, data);
    };
    DefectsService.prototype.getDefectsRecommendation = function () {
        return this.http.get(this.getApiUrl("getDefectsRecommendation"));
    };
    DefectsService.ngInjectableDef = i0.defineInjectable({ factory: function DefectsService_Factory() { return new DefectsService(i0.inject(i1.HttpClient)); }, token: DefectsService, providedIn: "root" });
    return DefectsService;
}(InterfaceService));
export { DefectsService };
